import { InputActionType, InputActionTypes } from "./InputActionType";
import { InputDeviceType, InputDeviceTypes } from "./InputDeviceType";

export class InputInteraction
{
  inputDevice:InputDeviceType;
  action:InputActionType;
  target:string;

  static Key( key:string ):InputInteraction
  {
    let ii = new InputInteraction();
    ii.inputDevice = InputDeviceTypes.Keyboard;
    ii.action      = InputActionTypes.Press;
    ii.target      = key;
    
    return ii;
  }
}
